export default function Modal(props) {
  if (!props.show)
    return null;
  return (
    <div className={"fixed z-40 top-0 left-0 w-full h-full flex justify-center items-center bg-gray-600 bg-opacity-50"}>
      {props.children}
    </div>
  )
}